import * as actions from './actions'

export const navigator = { actions }
export default navigator
